import { BuyCrypto, PaymentMethod, Payments } from '../../api/config/types';
import { CMSPaymentServicesDescription } from '../../types/paymentService';
import { parseServices } from '../parseServices';

interface CryptoConfig {
  fiatCurrencies?: { currency: string }[];
}

interface NormalizeCryptoServiceResult {
  crypto: PaymentMethod[];
  fiat: { currency: string }[];
}
const normalizeCryptoService = (
  { crypto = [], fiat = [] }: BuyCrypto = {},
  cryptoConfig: CryptoConfig = {}
): NormalizeCryptoServiceResult => {
  const { fiatCurrencies: availableFiatCurrencies = [] } = cryptoConfig;

  const allowedFiat = availableFiatCurrencies.filter(({ currency }) =>
    fiat.includes(currency)
  );

  return {
    crypto: Array.isArray(crypto) ? crypto : [],
    fiat: allowedFiat
  };
};

export const normalizePaymentServices = (
  {
    withdraw: withdrawServiceList = [],
    deposit: depositServiceList = [],
    buyCrypto,
    sellCrypto
  }: Payments,
  paymentServicesDescription: CMSPaymentServicesDescription,
  currency: string,
  cryptoConfig: CryptoConfig = {}
) => ({
  deposit: parseServices(
    'deposit',
    depositServiceList,
    paymentServicesDescription,
    currency
  ),
  withdraw: parseServices(
    'withdraw',
    withdrawServiceList,
    paymentServicesDescription,
    currency
  ),
  sellCrypto:
    sellCrypto && sellCrypto?.crypto
      ? parseServices(
          'sellCrypto' as 'deposit' | 'withdraw',
          sellCrypto.crypto,
          paymentServicesDescription,
          currency
        )
      : {},
  buyCrypto: normalizeCryptoService(buyCrypto, cryptoConfig)
});

export type NormalizedPaymentServices = ReturnType<
  typeof normalizePaymentServices
>;
